import ApexCharts from 'apexcharts';

let chart = null;

function buildOptions(data) {
  const themeColors = getChartColors();

  return {
    chart: {
      height: 420,
      type: 'line',
      fontFamily: 'Inter, sans-serif',
      toolbar: { show: false },
      foreColor: themeColors.labelColor,
    },
    dataLabels: { enabled: false },
    stroke: { curve: 'smooth', width: 2 },
    grid: {
      show: true,
      borderColor: themeColors.gridColor,
      strokeDashArray: 1,
      padding: { left: 35, bottom: 15 }
    },
    series: [
      { name: 'Все', data: data.series_total, color: '#1A56DB' },
      { name: 'Валидные', data: data.series_valid, color: '#22C55E' },
      { name: 'Невалидные', data: data.series_invalid, color: '#EF4444' },
      { name: 'Не удалось проверить', data: data.series_unknown, color: '#D97706' }
    ],
    xaxis: {
      categories: data.labels,
      axisBorder: { color: themeColors.gridColor },
      axisTicks:  { color: themeColors.gridColor },
    },
    yaxis: {
    },
    legend: {
      fontSize: '14px',
      fontWeight: 500,
      fontFamily: 'Inter, sans-serif',
      labels: {
        colors: [themeColors.labelColor]
      }
    }
  };
}

function getChartColors() {
  if (document.documentElement.classList.contains('dark')) {
    return {
      labelColor: '#9CA3AF',
      gridColor: '#374151',
    };
  } else {
    return {
      labelColor: '#6B7280',
      gridColor: '#F3F4F6',
    };
  }
}

// Запрашиваем JSON с сервера
async function loadData(dayRange) {
  const resp = await fetch(`/api/stats_data/?range=${dayRange}`);
  const data = await resp.json();

  const filesCountEl = document.getElementById('files-count');
  if (filesCountEl && 'files_count' in data) {
    filesCountEl.textContent = data.files_count;
  }

  const options = buildOptions(data);

  if (!chart) {
    chart = new ApexCharts(document.querySelector('#main-chart'), options);
    await chart.render();
  } else {
    await chart.updateOptions(options);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // По умолчанию 7 дней
  loadData(7);

  const daysBtn = document.getElementById('days-btn');
  const daysLabel = document.getElementById('days-label');
  const dropdown = document.getElementById('days-dropdown');

  // Раскрытие dropdown
  daysBtn.addEventListener('click', () => {
    dropdown.classList.toggle('hidden');
  });

  const dayOptions = dropdown.querySelectorAll('.days-option');
  dayOptions.forEach(opt => {
    opt.addEventListener('click', (evt) => {
      evt.preventDefault();
      dropdown.classList.add('hidden');
      const r = opt.getAttribute('data-range');
      daysLabel.textContent = `Последние ${r} дней`;
      loadData(r);
    });
  });
});

